import React from 'react';
import { Link } from 'react-router-dom';
import './FastTrack.css'
import { Col, Row, Container } from 'react-bootstrap';
import ProjectList from '../components/ProjectList';

const programGuidanceLink = 'https://pa.gov/content/dam/copapwp-pagov/en/oto/pa%20permit%20fast%20track%20program%20guidance.pdf'
const programEOLink = 'https://pa.gov/content/dam/copapwp-pagov/en/governor/documents/eo-2024-04_pa%20permit%20fast%20track%20program.pdf'
const paybackLink = 'https://payback.pa.gov/Home/Who'
const gridPrinciplesLink = 'https://pa.gov/GRIDstandards'

function FastTrack() {
  return (
    <Container>
      <Row>
        <Col>
          <h1 className="kds-headline kds-headline-lg home-title">PA Permit Fast Track Program</h1>
          <h4 className="kds-headline kds-headline-sm home-subtitle">What is the Fast Track program and why is it being offered?</h4>
          <p className="kds-body kds-body-lg home-description">
            The PA Permit Fast Track Program streamlines permitting for high-impact economic development and infrastructure projects through coordinated, transparent, and predictable interagency review.
          </p>
          <p className="kds-body kds-body-lg home-description">
            Administered by the Office of Transformation & Opportunity, the program helps project sponsors navigate permitting requirements and avoid costly delays. Fast Track coordinates meetings across state agencies, clarifies next steps, and provides timely, collaborative responses among all parties. Importantly, it maintains the same rigorous review standards applied to all permit applications across the Commonwealth, streamlining economic growth without sacrificing environmental and public health protections.
          </p>
          <p className="kds-body kds-body-lg home-description">
            The PA Permit Fast Track Program and <a className="kds-link kds-link-inline kds-link-lg" href={programGuidanceLink}>Guidance</a> were authorized by <a className="kds-link kds-link-inline kds-link-lg" href={programEOLink}>Executive Order</a> as part of Governor Shapiro's permit reform initiatives, including the <a className="kds-link kds-link-inline kds-link-lg" href={paybackLink}>PAyback Program</a> that refunds fees for delayed permits.
          </p>
          {/* TODO: Add back with EO 2026-05*/}
          {/* <h4 className="kds-headline kds-headline-sm home-subtitle">The Governor's Responsible Infrastructure Development (GRID) Standards</h4>
          <p className="kds-body kds-body-lg home-description">
            Based on the GRID Standards, data center development projects will be asked to submit additional information through the existing application for the PA Permit Fast Track Program. Additional information on the GRID Standards is available <a className="kds-link kds-link-inline kds-link-lg" href={gridPrinciplesLink}>here</a>.
          </p> */}
          <p className="apply-link">
            <Link className="kds-button kds-button-filled" to="/intake">Apply to Fast Track</Link>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2 className="kds-headline kds-headline-lg project-title">Fast Track Projects</h2>
          <ProjectList />
          <p>
            <Link to="/intake" className="kds-button kds-button-filled apply-btn">Apply to Fast Track</Link>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2 className="kds-headline kds-headline-lg glossary-title" id="permit-glossary">Key Permit Glossary</h2>

          <h3 className="kds-title kds-title-lg department-title">Department of Environmental Protection</h3>
          <ul className="kds-body kds-body-lg permit-list">
            <li>
              <strong>Chapter 102 NPDES Permit for Construction Stormwater:</strong> A National Pollutant Discharge Elimination System (NPDES) is required if the earth disturbance associated with proposed construction will be 1 acre or more.
            </li>
            <li>
              <strong>Chapter 102 NPDES Permit for Industrial Stormwater:</strong> Specific classes of facilities are required to obtain NDPES permit coverage for discharges of stormwater associated with industrial activities.
            </li>
            <li>
              <strong>Chapter 105 Permit:</strong> Required if a project proposes any water obstructions and/or encroachments located in, along or across, or projecting into a watercourse, floodway or body of water, whether temporary or permanent.
            </li>
            <li>
              <strong>Water Quality Management Permit:</strong> Required for the construction and operation of a manure digester system.
            </li>
            <li>
              <strong>Air Quality Permit:</strong> Required for the construction and operation of air pollutant emission sources.
            </li>
            <li>
              <strong>Act 537:</strong> Required to address sewage disposal needs and planning requirements in collaboration with municipalities.
            </li>
          </ul>

          <h3 className="kds-title kds-title-lg department-title">Pennsylvania Department of Transportation</h3>
          <ul className="kds-body kds-body-lg permit-list">
            <li>
              <strong>Highway Occupancy Permits (HOPs):</strong> Required to access a state-owned right-of-way.
            </li>
            <li>
              <strong>Traffic Impact Study (TIS):</strong> May be required as part of an HOP or otherwise to identify the impact of a proposed access point on transportation in the surrounding area.
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default FastTrack;
